import { ComplaintActions } from "../actions";

const initialState = {
  complaints: {
    rows: [],
    rowCount: 0,
    pageCount: 0,
  },
  complaint: null,
};

export default function complaint(state = initialState, action) {
  switch (action.type) {
    case ComplaintActions.ACTION_SAVE_COMPLAINTS:
      return {
        ...state,
        complaints: action.payload,
      };
    case ComplaintActions.ACTION_SAVE_COMPLAINT:
      return {
        ...state,
        complaint: action.payload,
      };
    default:
      return state;
  }
}

export function getComplaints(state) {
  return state.complaint.complaints;
}

export function getComplaint(state) {
  return state.complaint.complaint;
}

